export const formatStoreAddress = (addressDescription) => (
  <address>
    <b>{addressDescription.split("\n")[0]}</b>
    <br />
    {addressDescription.split("\n")[1]}
  </address>
);
